module.exports = __webpack_public_path__ + "static/bouyguesTelecom-a25096a9e4290b7139814ea190b9e4e1.svg";